/**
 * Orders
 */

// React
import React, {FunctionComponent, useEffect, useState, useContext} from 'react';
import useQuery from '../../../utils/hook/useQuery';

// Context
import AuthContext, {AuthConsumer} from '../../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getOrdersAction,
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  actionRetrieveRubikaOrdersAction,
  cancelOrderAction,
  getAllOrdersReportAction,
} from '.././actions';
import {Store} from '../../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllOrders,
  makeSelectProcessingCountList,
  makeSelectDeliveredCountList,
  makeSelectDeliveringCountList,
  makeSelectDeliverdPostCountList,
} from '.././selectors';

// UI
import theme from '../../../theme';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Menu,
  Fade,
  Backdrop,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';
import {
  mdiAccountKeyOutline,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiHomeSearchOutline,
  mdiPackageVariant,
  mdiStateMachine,
  mdiCalendar,
  mdiClose,
  mdiHomeCityOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiPlusBoxOutline,
  mdiPlusBox,
  mdiTuneVerticalVariant,
} from '@mdi/js';
import {Box, Trolley, Truck, Deliverd} from '.././customIcon';

// Components
import RenderFilter from '../../../utils/listDaynamicFilterHookFormMob';
import type {Filter} from '../../../utils/listDaynamicFilter';
import List from './list';
import Pagination from '@material-ui/lab/Pagination';
import Can from '../../../components/Can';
import CSV from '.././csv';
import ExelExport from '.././components/exelExport';

// Helper
import {removeEmptyValueObject, translate} from '../../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  Payload,
  Status,
  cancelPayload,
  PayloadAllUpdate,
} from '.././interfaces';
import {Link} from 'react-router-dom';
import classes from './ordersMob.module.scss';

// Style

const OrdersMob: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const {filtersValues, setFiltersValues} = useQuery({page: 0, size: 10});
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [id, setId] = useState(-1 as number);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [cancelDescription, setCancelDescription] = useState('' as string);
  const [lastUpdate, setLastUpdate] = useState(
    '2019-07-02T17:15:03+04:30' as string
  );
  const [showList, setShowList] = useState(false);
  const convertArrayItemsToString = () => {
    const array = props.allOrders;
    const reducer = (total: any, currentValue: any) => total + currentValue;
    const newArray = array.map(obj => {
      return {
        ...obj,
        items: obj.items.reduce(reducer).productName,
      };
    });
    return newArray;
  };
  // Bad Bad Bad.. :(
  props.ordersList[0]?.created &&
    props.ordersList[0]?.created > lastUpdate &&
    setLastUpdate(props.ordersList[0]?.created);

  useEffect(() => {
    getOrders();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const getOrders = () => {
    const {page, size} = filtersValues;
    props.ordersDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            icon: mdiStateMachine,
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'SUPPLYING',
              'CANCELLED',
            ],
            translateType: 'Order',
          },
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'customerMobileNumber.contains',
            label: 'شماره همراه ',
            icon: mdiPhoneOutline,
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش',
            icon: mdiPackageVariant,
          },

          {
            type: 'input',
            id: 'trackingCode.contains',
            label: 'کد پیگیری',
            icon: mdiPackageVariant,
          },
          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی',
            icon: mdiPackageVariant,
          },

          {
            type: 'input',
            id: 'centerName.contains',
            label: 'نام مرکز',
            icon: mdiHomeSearchOutline,
          },

          {
            type: 'input',
            id: 'customerProvinceName.contains',
            label: 'نام استان',
            icon: mdiHomeCityOutline,
          },
          {
            type: 'input',
            id: 'customerCity.contains',
            label: 'نام شهر',
            icon: mdiHomeCityOutline,
          },

          {
            type: 'date-picker-time',
            id: 'created.greaterThanOrEqual',
            label: 'تاریخ ثبت سفارش از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker-time',
            id: 'created.lessThanOrEqual',
            label: 'تا تاریخ ثبت سفارش  ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل ',
            icon: mdiCalendar,
          },
          {
            type: 'checkbox',
            id: 'paymentType.in',
            label: 'شیوه پرداخت',
            icon: mdiStateMachine,
            data: [
              'COD','ONLINE'
            ],
            translateType: 'COD',
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'customerPhoneNumber.contains',
            label: 'شماره همراه سفارش‌دهنده',
            icon: mdiPhoneOutline,
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش',
            icon: mdiPackageVariant,
          },

          // {
          //   type: 'input',
          //   id: 'trackingCode.contains',
          //   label: 'شناسه پیگیری',
          // },

          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی',
            icon: mdiAccountKeyOutline,
          },
          // {
          //   type: 'input',
          //   id: 'centerProvince.contains',
          //   label: 'نام  استان',
          // },
          // {
          //   type: 'input',
          //   id: 'centerCity.contains',
          //   label: 'نام  شهر',
          // },

          // {
          //   type: 'date-picker-time',
          //   id: 'created.greaterThanOrEqual',
          //   label: 'تاریخ ثبت سفارش از ',

          // }, {
          //   type: 'date-picker-time',
          //   id: 'created.lessThanOrEqual',
          //   label: 'تا تاریخ ثبت سفارش  ',

          // },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل ',
            icon: mdiCalendar,
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            icon: mdiStateMachine,
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'SUPPLYING',
              'CANCELLED',
            ],
            translateType: 'Order',
          },
          {
            type: 'checkbox',
            id: 'paymentType.in',
            label: 'شیوه پرداخت',
            icon: mdiStateMachine,
            data: [
              'COD','ONLINE'
            ],
            translateType: 'COD',
          },
        ]);
      },
    });
  };

  const handleCancelOrder = async () => {
    await props.cancelOrderDispatch({
      id,
      body: {description: cancelDescription},
    });
    getOrders();
    setOpenConfirmCancel(false);
  };

  const handleCardClose = () => {
    delete filtersValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10,
    });
  };
  const handleCardClick = (name: any) => {
    switch (name) {
      case 'progress':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ASSIGNED', 'PICKED', 'PACKAGED', 'BUNDLED'],

          page: 0,
          size: 10,
        });
        break;
      case 'courier':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['LOADED', 'DELIVERED_TO_COURIER'],

          page: 0,
          size: 10,
        });
        break;
      case 'delivered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED'],
          page: 0,
          size: 10,
        });
        break;
      case 'post':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED_TO_POST'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const changeStatusOrder = () => {
    props.updateOrderStatusDispatch({
      id,
      body: {status: previewState, description: ''},
      pagination: filtersValues,
    });
    setOpenConfirmUpdateState(false);
  };
  const changeStatusOrderWhitId = (data: any) => {
    const {ids, status, description} = data;
    props.updateAllOrderStatusDispatch({
      ids,
      status,
      description,
      pagination: filtersValues,
    });

    // props.updateOrderStatusDispatch({
    //   id,
    //   body,
    //   pagination: filtersValues,
    // });
    setOpenConfirmUpdateState(false);
  };

  const handleOpenConfirmCancele = (id: number) => {
    setOpenConfirmCancel(true);
    setId(id);
  };
  const handleOpenConfirmUpdateState = (data: {id: number; body: Status}) => {
    setOpenConfirmUpdateState(true);
    setId(data.id);
    setPreviewState(data.body);
  };

  const handleClose = () => {
    setOpenConfirmCancel(false);
    setOpenConfirmUpdateState(false);
    setOpenSize(false);
  };

  const findOrderStatus = (id: number) => {
    const status = props.ordersList.find(order => order.id === id)?.status;
    return status && translate(status, 'order');
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'progress':
        return (
          status.includes('ASSIGNED') &&
          status.includes('PICKED') &&
          status.includes('PACKAGED') &&
          status.includes('BUNDLED')
        );
      case 'courier':
        return (
          status.includes('LOADED') && status.includes('DELIVERED_TO_COURIER')
        );
      case 'delivered':
        return status.includes('DELIVERED');
      case 'post':
        return status.includes('DELIVERED_TO_POST');
    }
  };
  const toggleList = () => {
    setShowList(!showList);
  };
  const handleClickMenu = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <AuthConsumer>
      {({user}) => (
        <div className={classes.root}>
          <Grid container>
            <div
              style={{
                zIndex: 10,
                position: 'fixed',
                top: '16px',
                right: '70px',
                display: 'flex',
                width: '80%',
              }}
            >
              <div>
                <Typography variant="h6" component="h2">
                  {` مدیریت سفارش‌ها`}
                </Typography>
              </div>
              <Button
                id="fade-button"
                aria-controls="fade-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClickMenu}
                style={{marginRight: 'auto'}}
              >
                <Icon path={mdiPlusBox} size={1.5} color="#2f4858" />
              </Button>
              <Backdrop
                open={open}
                onClick={handleCloseMenu}
                style={{zIndex: 100}}
              />
              <Menu
                id="fade-menu"
                MenuListProps={{
                  'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                TransitionComponent={Fade}
                style={{marginTop: '40px'}}
              >
                <MenuItem onClick={handleCloseMenu} className={classes.hover}>
                  {' '}
                  <Link
                    to={'/orders-create'}
                    style={{
                      textDecoration: 'none',
                    }}
                  >
                    ایجاد سفارش
                  </Link>
                </MenuItem>
                <MenuItem onClick={handleCloseMenu}>
                  <Link
                    to={'/create-grouping-order'}
                    style={{
                      textDecoration: 'none',
                    }}
                  >
                    ایجاد گروهی سفارش
                  </Link>
                </MenuItem>
              </Menu>

              <div className={classes.filterHolder}>
                <RenderFilter
                  filters={filters}
                  onFilter={(filtervalues: any) => {
                    setFiltersValues({
                      ...removeEmptyValueObject(filtervalues),
                      page: 0,
                      size: 10,
                    });
                  }}
                  mainFiltersCount={0}
                  baseFilter={{
                    type: 'input',
                    id: 'trackingCode.contains',
                    placeholder: 'کد پیگیری',
                  }}
                  filterValues={filtersValues}
                  toggleList={toggleList}
                  name={'سفارش ها'}
                />
              </div>
            </div>
          </Grid>

          <Grid container spacing={1} xs={12} style={{marginTop: '60px'}}>
            <Grid item xs={6}>
              <Card
                className={
                  checkActiveCard('progress')
                    ? classes.boxshadow
                    : classes.cards
                }
              >
                <CardContent
                  className={classes.cardContent}
                  style={{padding: 0}}
                >
                  <IconButton
                    type="submit"
                    onClick={name => handleCardClick('progress')}
                    aria-label="search"
                    style={{
                      backgroundColor: '#FFEDDE',
                      width: '50%',
                      borderRadius: '4px',
                    }}
                    data-cy="progressCardBtn"
                  >
                    <Trolley />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 500}}
                      data-cy="processingCount"
                    >
                      {props.processingCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      در حال پردازش
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card
                className={
                  checkActiveCard('courier') ? classes.boxshadow : classes.cards
                }
              >
                <CardContent
                  className={classes.cardContent}
                  style={{padding: 0}}
                >
                  <IconButton
                    type="submit"
                    aria-label="search"
                    onClick={name => handleCardClick('courier')}
                    style={{
                      backgroundColor: '#DFE3FD',
                      borderRadius: '4px',
                      width: '50%',
                    }}
                    data-cy="courierCardBtn"
                  >
                    <Truck />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 500}}
                      data-cy="deliveringCount"
                    >
                      {props.deliveringCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      تحویل پیک شده
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card
                className={
                  checkActiveCard('post') ? classes.boxshadow : classes.cards
                }
              >
                <CardContent
                  className={classes.cardContent}
                  style={{padding: 0}}
                >
                  <IconButton
                    type="submit"
                    aria-label="search"
                    onClick={name => handleCardClick('post')}
                    style={{
                      backgroundColor: '#E9CAF2',
                      borderRadius: '4px',
                      height: '40%',
                    }}
                    data-cy="postCardBtn"
                  >
                    <Deliverd />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 500}}
                      data-cy="deliverdPostCount"
                    >
                      {props.deliverdPostCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#666666',
                      }}
                    >
                      تحویل پست
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card
                className={
                  checkActiveCard('delivered')
                    ? classes.boxshadow
                    : classes.cards
                }
              >
                <CardContent
                  className={classes.cardContent}
                  style={{padding: 0}}
                >
                  <IconButton
                    type="submit"
                    aria-label="search"
                    onClick={name => handleCardClick('delivered')}
                    style={{
                      backgroundColor: '#D6EBD3',
                      borderRadius: '4px',
                    }}
                    data-cy="deliveredCardBtn"
                  >
                    <Box />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 500}}
                      data-cy="deliveredCount"
                    >
                      {props.deliveredCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      تحویل مشتری
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            {/* <Grid item lg={4} xs={6}>
        <Card className={classes.chart}>
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography className={classes.typographyCards}>
              تعداد آیتم‌های محموله
            </Typography>
            <Select value={'۷ روز گذشته'}>
              <MenuItem value={'۷ روز گذشته'}>۷ روز گذشته</MenuItem>
            </Select>
          </Grid>
          <div style={{marginTop: '10px'}}>
            <Chart data={data} height={230}>
              <ArgumentAxis />
              <ValueAxis position={'right'} />

              <LineSeries valueField="value" argumentField="argument" />
              <EventTracker />
              <Tooltip />
            </Chart>
          </div>
        </Card>
      </Grid> */}
            {/* <Grid item lg={3} xs={6}>
        <Card className={classes.progress}>
          <Typography
            className={classes.typographyCards}
            style={{
              width: '60%',
              textAlign: 'end',
            }}
          >
            محموله هر انبار
          </Typography>
          <div style={{textAlign: 'center', margin: '30px auto'}}>
            <CircularProgress
              size={140}
              style={{
                position: 'relative',
                color: '#6276F7',
                // bottom: '-20%',
                // right: '30%',
              }}
              variant="determinate"
              value={60}
              thickness={6}
            />
            <Typography
              style={{
                position: 'relative',
                bottom: '85px',
                fontWeight: 900,
              }}
              variant="caption"
              component="div"
              color="textSecondary"
            >
              {'754 سفارش'}
            </Typography>
          </div>
        </Card>
      </Grid> */}
          </Grid>

          <Grid container spacing={1} style={{marginTop: '20px'}}>
            {showList && (
              <Card>
                <CardContent className={classes.cardContentOrder}>
                  <Grid
                    container
                    lg={12}
                    md={12}
                    className={classes.cardContentlist}
                  >
                    <Grid container item lg={12} md={12}>
                      <Grid container item xs={12} md={12} lg={12}>
                        {props.loading ? (
                          <div className={classes.loading}>
                            <CircularProgress />
                          </div>
                        ) : (
                          <>
                            {props.ordersList?.length > 0 ? (
                              <List
                                data={props.ordersList}
                                handleConfirmCanceleBox={
                                  handleOpenConfirmCancele
                                }
                                changeStatusOrderWhitId={
                                  changeStatusOrderWhitId
                                }
                                handleOpenConfirmUpdateState={
                                  handleOpenConfirmUpdateState
                                }
                              />
                            ) : (
                              <Typography variant="h3" component="div">
                                سفارشی موجود نیست
                              </Typography>
                            )}
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{padding: '20px 10px 0 10px'}}
                      >
                        {props.ordersList.length > 0 && (
                          <FormControl
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                              {' '}
                              تعداد نمایش در هر صفحه:
                            </div>
                            <Select
                              open={openSize}
                              onClose={handleClose}
                              onOpen={() => setOpenSize(true)}
                              value={filtersValues.size}
                              onChange={handleChangeSizePage}
                            >
                              <MenuItem value={10}>10</MenuItem>
                              <MenuItem value={20}>20</MenuItem>
                              <MenuItem value={50}>50</MenuItem>
                              <MenuItem value={100}>100</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                      <Grid
                        xs={12}
                        sm={6}
                        container
                        item
                        direction="row-reverse"
                        style={{padding: '20px 10px 0 10px'}}
                      >
                        {props.ordersList.length > 0 && (
                          <Pagination
                            className={classes.pagination}
                            count={Math.ceil(props.count / filtersValues.size)}
                            color="secondary"
                            page={filtersValues.page + 1}
                            onChange={handleChangePage}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
          </Grid>

          <Dialog
            open={openConfirmCancel}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '3px',
                  top: '10px',
                  zIndex: 10,
                }}
              >
                {handleClose ? (
                  <IconButton
                    aria-label="close"
                    // className={classes.closeButton}
                    onClick={handleClose}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>

              <div
                className={classes.cancelTitle}
              >{`از لغو سفارش با شناسه ${id} مطمئن هستید؟`}</div>
              <Grid item xs={12} style={{marginTop: '16px'}}>
                <TextField
                  variant="outlined"
                  className={classes.textArea}
                  placeholder={`علت لغو...`}
                  value={cancelDescription}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setCancelDescription(e.target.value)
                  }
                />
              </Grid>
              <Divider style={{width: '100%', marginTop: '16px'}} />
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                style={{textAlign: 'center', marginBottom: '8px'}}
              >
                <Grid item xs={12}>
                  <Button
                    style={{marginLeft: '8px'}}
                    autoFocus
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                    size="large"
                    data-cy="closeCancelation"
                  >
                    {`انصراف
`}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCancelOrder}
                    disabled={!(cancelDescription.length > 0)}
                    size="large"
                    data-cy="submitCancelation"
                    color="primary"
                  >
                    {`لغو سفارش`}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          <Dialog
            fullWidth
            open={openConfirmUpdateState}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                {handleClose ? (
                  <IconButton
                    aria-label="close"
                    // className={classes.closeButton}
                    onClick={handleClose}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiPencilOutline}
                  size={4}
                  color={theme.palette.blue.main}
                />
              </div>
              <div className={classes.cancelTitle}>
                {`از تغییر تگ وضعیت سفارش
              با شناسه  ${id} از
"${id > -1 && findOrderStatus(id)}"
به
" ${translate(previewState.replace(/"/g, '') as Status, 'order')}"


مطمئن هستید؟`}
              </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    size="large"
                    data-cy="closeChangeTag"
                  >
                    {`خیر`}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={changeStatusOrder}
                    size="large"
                    data-cy="submitChangeTag"
                  >
                    {`بله`}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </AuthConsumer>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  deliveringCount: makeSelectDeliveringCountList(),
  deliveredCount: makeSelectDeliveredCountList(),
  processingCount: makeSelectProcessingCountList(),
  deliverdPostCount: makeSelectDeliverdPostCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    actionRetrieveRubikaOrdersDispatch: (payload: {
      date?: String;
      from?: number;
      to?: number;
    }) => dispatch(actionRetrieveRubikaOrdersAction(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(OrdersMob);
